module.exports = __webpack_public_path__ + "img/ecommerce-development-calicut.76fadcfb.png";